/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SearchBillersRequest} from '@cash-web/protos/squareup/cash/billy/api/v1_0/app/SearchBillers.pb'
import {SearchBillersResponse} from '@cash-web/protos/squareup/cash/billy/api/v1_0/app/SearchBillers.pb'


export const searchBillers = (request:SearchBillersRequest, options?: CashRequestOptions) => post<SearchBillersRequest, SearchBillersResponse>("/cash-app/bills/v1.0/app/search-billers", request, {...options, rejectOnError: true })